import React, { useCallback, useState } from "react";

import {
  FeatureAndShoeCareSheetContent,
  type FeatureAndShoeCareProps,
} from "~/templates/product/FeatureAndShoeCareSheet";

import { Button, IconPodiatry, IconChevron } from "@bared/ui";

export function FeaturesButton({
  gender,
  productName,
}: FeatureAndShoeCareProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSheetToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);
  return (
    <>
      <div>
        <Button
          variant="round"
          size="small"
          onClick={handleSheetToggle}
          className="flex items-center gap-pico !px-[10px] font-medium"
        >
          <IconPodiatry className="w-mini md:w-[20px]" />
          Podiatrist Designed
          <IconChevron className="w-[10px] rotate-[270deg]" />
        </Button>
      </div>

      <FeatureAndShoeCareSheetContent
        productName={productName}
        gender={gender}
        activeTab="feature"
        isOpen={isOpen}
        handleSheetToggle={handleSheetToggle}
        setIsOpen={setIsOpen}
      />
    </>
  );
}
